(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name PeticionController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('PeticionController', PeticionController);

    PeticionController.$inject = ["MaterialesService","CodigosService","Upload","$uibModal","GenerallabService","AnimalesService","AnalisisService","$timeout","$location",'$anchorScroll','$window'];

    function PeticionController(MaterialesService,CodigosService,Upload,$uibModal,GenerallabService,AnimalesService,AnalisisService,$timeout,$location,$anchorScroll,$window)
    {
        //console.log("PeticionController Enabled");
        var vm = this;

        vm.tipoAnalisis = 1;
        vm.animalesCentro = [];
        vm.loadingParams = false;
        vm.showCart = false;
        vm.generalLab = GenerallabService;
        vm.animalSeleccionado = false;
        vm.recomendacion = false;
        vm.comenzarAnalitica = false;
        vm.paramsExtra = {acuerdocomercial_id : false, grupocompra_id : false};
        vm.subcategorias = [];
        vm.transporteEstimado = false;
        vm.materialId = {};
        vm.fields = { 
            ficheros : [],
            extra : { 
                tratamientos : [{tratamiento:'',respuesta:''}],
                productos_tratamiento : [{product:'',dosis:'','desde':''} ]
            }
        };
        vm.tiposAnalisis = [];
        vm.loadingPaciente = false;

        vm.reglasActivas = [];
        
        vm.tipoMuestras = [];
        vm.tipoSeleccionado = [];
        vm.filtrosMuestra = {};
        vm.buscador = { nombre : ""};
            vm.loadingSave = false;

        vm.filtrosPaciente = { page:0 };
        vm.peticion_id = "";
        vm.analiticas = [];
        vm.filtros = {};
        vm.analiticasCarrito = [];
        vm.loadingMuestraUn = false;
        vm.razas = [];
        vm.especies = [];
        vm.muestraSeleccionada = {};
        vm.loadingMuestras = false;
        vm.perfiles = [];
        vm.analisis = [];
        vm.paso = 1;
        vm.loadingPacientes = false;
        vm.tiposNecesarias = {}; 
        vm.newAnimal = {};

        vm.generalLab.optionsEspecies.ajax.data = function (params) {
            return {
              q: params.term, // search term
              page: params.page,
              lang_id: lang_id,
              categoriaespecie: vm.newAnimal.categoriaespecie_id,
              per_page: 20
            };
        };

        vm.generalLab.optionsVet.ajax.data = function (params) {
            return {
              q: params.term, // search term
              page: params.page,
              lang_id: lang_id,
              categoriaespecie: vm.newAnimal.categoriaespecie_id,
              centro_id:vm.fields.centro_id,
              per_page: 20
            };
        };

        

        vm.generalLab.optionsMultiplePicker.changeCallback = function(){
            $timeout(function(){
                vm.getMuestras();
            });
        }
        vm.generalLab.optionsMultiplePicker.eventHandlers = {
            'cancel.daterangepicker': function(event, picker) { $timeout(function(){
                vm.getMuestras();
            }); }
        }

        vm.datetomaoptions = {
            
            maxDate : moment(),
            opens:'center',
            alwaysShowCalendars: true,
            showCustomRangeLabel: false,
            locale: {
                applyLabel: "Aplicar",
                cancelLabel: 'Cancelar',
                clearLabel: 'Limpiar',
                separator: ' - ',
                format: "DD-MM-YYYY",
            },
            ranges: {
                'Hoy': [moment(), moment()],
                'Ayer': [moment().subtract(1, 'day'), moment().subtract(1, 'day')],
                'Últimos 7 días': [moment().subtract(6, 'days'), moment()],
                'Últimos 30 días': [moment().subtract(29, 'days'), moment()],
                'Mes actual': [moment().startOf('month'), moment().endOf('month')],
                'Mes anterior': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
            },
            eventHandlers: {
                'apply.daterangepicker': function(event, picker) { $timeout(function(){
                    vm.getMuestras();
                }); },
                'cancel.daterangepicker': function(event, picker) { $timeout(function(){
                    vm.getMuestras();
                }); }
            }
        };
        vm.dateresultsoptions = {
            singleDatePicker: true,
            maxDate : moment(),
            opens:'center',
            alwaysShowCalendars: true,
            showCustomRangeLabel: false,
            locale: {
                applyLabel: "Aplicar",
                cancelLabel: 'Cancelar',
                clearLabel: 'Limpiar',
                separator: ' - ',
                format: "DD-MM-YYYY",
            },
            ranges: {
                'Hoy': [moment(), moment()],
                'Ayer': [moment().subtract(1, 'day'), moment().subtract(1, 'day')],
                'Últimos 7 días': [moment().subtract(6, 'days'), moment()],
                'Últimos 30 días': [moment().subtract(29, 'days'), moment()],
                'Mes actual': [moment().startOf('month'), moment().endOf('month')],
                'Mes anterior': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
            },
            eventHandlers: {
                'apply.daterangepicker': function(event, picker) { $timeout(function(){
                    vm.getMuestras();
                }); },
                'cancel.daterangepicker': function(event, picker) { $timeout(function(){
                    vm.getMuestras();
                }); }
            }
        };



        vm.optionsEspeciesFil = {
            ajax: {
                headers: { 'Content-Type': 'application/json' },
                url: "/uranolab/getespecies",
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                      q: params.term, // search term
                      page: params.page,
                      lang_id: lang_id,
                      per_page: 20
                    };
                },
                processResults: function (data, params) {
                    // parse the results into the format expected by Select2
                    // since we are using custom formatting functions we do not need to
                    // alter the remote JSON data, except to indicate that infinite
                    // scrolling can be used
                    params.page = params.page || 1;
                    return {
                      results: data.items,
                      pagination: {
                        more: (params.page * 1) < data.total_count
                      }
                    };
                }
            }
        };

        vm.optionsRacesFil = {
            ajax: {
                headers: { 'Content-Type': 'application/json' },
                url: "/uranolab/getraces",
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                      q: params.term, // search term
                      page: params.page,
                      lang_id: lang_id,
                      especieseleccionada: vm.filtrosPaciente.especie,
                      per_page: 20
                    };
                },
                processResults: function (data, params) {
                    // parse the results into the format expected by Select2
                    // since we are using custom formatting functions we do not need to
                    // alter the remote JSON data, except to indicate that infinite
                    // scrolling can be used
                    params.page = params.page || 1;
                    return {
                      results: data.items,
                      pagination: {
                        more: (params.page * 1) < data.total_count
                      }
                    };
                }
            },
            templateSelection: vm.format,
            templateResult: vm.format
        };
       

        vm.optionsEspecies = {
            ajax: {
                headers: { 'Content-Type': 'application/json' },
                url: "/uranolab/getespecies",
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                      q: params.term, // search term
                      page: params.page,
                      lang_id: lang_id,
                      categoriaseleccionada: vm.newAnimal.categoriaespecie_id,
                      per_page: 20
                    };
                },
                processResults: function (data, params) {
                    // parse the results into the format expected by Select2
                    // since we are using custom formatting functions we do not need to
                    // alter the remote JSON data, except to indicate that infinite
                    // scrolling can be used
                    params.page = params.page || 1;
                    return {
                      results: data.items,
                      pagination: {
                        more: (params.page * 1) < data.total_count
                      }
                    };
                }
            }
        };

        vm.infoModalSJ = "";
        vm.abrirInfoSJ = function(dato){
            vm.infoModalSJ = $uibModal.open({
                  animation: true,
                  ariaLabelledBy: 'modal-title-top',
                  ariaDescribedBy: 'modal-body-top',
                  templateUrl: 'infomodalSJ.html',
                  size: 'sm',
                  backdrop:'static',
                  controller: function($scope) {
                     $scope.popup = dato
                    $scope.okForm = function(){
                        vm.infoModalSJ.close();
                    }
                   
                  }
              });
        }

        //vm.abrirInfoSJ();

        vm.uploadFiles = function (files) {
          if (files && files.length) {
            for (var i = 0; i < files.length; i++) {
              Upload.upload({
                    url: '/uranolab/subirimagenpeticion',
                    data: { file: files[i] }
                }).then(function (resp) {
                    //onsole.log(resp);
                    vm.fields.ficheros.push(resp.data);
                    //console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
                }, function (resp) {
                    //console.log('Error status: ' + resp.status);
                }, function (evt) {
                    var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                    //console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
                });
            }
            
          }
        }

        vm.optionsRacesNew = {
            ajax: {
                headers: { 'Content-Type': 'application/json' },
                url: "/uranolab/getraces",
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                      q: params.term, // search term
                      page: params.page,
                      lang_id: lang_id,
                      especieseleccionada: vm.newAnimal.especie_id,
                      per_page: 20
                    };
                },
                processResults: function (data, params) {
                    // parse the results into the format expected by Select2
                    // since we are using custom formatting functions we do not need to
                    // alter the remote JSON data, except to indicate that infinite
                    // scrolling can be used
                    params.page = params.page || 1;
                    return {
                      results: data.items,
                      pagination: {
                        more: (params.page * 1) < data.total_count
                      }
                    };
                }
            },
            templateSelection: vm.format,
            templateResult: vm.format
        };

        vm.optionsSex = {
            ajax: {
                headers: { 'Content-Type': 'application/json' },
                url: "/uranolab/getsexos",
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                      q: params.term, // search term
                      page: params.page,
                      lang_id: lang_id,
                      per_page: 20
                    };
                },
                processResults: function (data, params) {
                    // parse the results into the format expected by Select2
                    // since we are using custom formatting functions we do not need to
                    // alter the remote JSON data, except to indicate that infinite
                    // scrolling can be used
                    params.page = params.page || 1;
                    return {
                      results: data.items,
                      pagination: {
                        more: (params.page * 1) < data.total_count
                      }
                    };
                }
            },
            templateSelection: vm.format,
            templateResult: vm.format
        };

        vm.eliminarLesion = function(aExtra,index){
               aExtra.muestras.splice(index,1);
        }

        /*vm.existeTipoMuestra = function(limps_id){
            var res = false;
            for(var cont=0;cont<vm.tiposNecesarias.length && !res;cont++){
                if(vm.tiposNecesarias[cont].limps_id == limps_id){
                    res = cont;
                }
            }
            return res;
        }*/

        vm.getTiposMuestraNecesarias = function(){
            //vm.tiposNecesarias = {};
            if(Object.keys(vm.tiposNecesarias).length>0){
                for(var key in vm.tiposNecesarias){
                    vm.tiposNecesarias[key].checked = false;
                    vm.tiposNecesarias[key].disabled = false;
                }
             
            }
            //console.log(vm.tiposNecesarias);
            for(var cont=0;cont<vm.analiticasCarrito.length;cont++){
                if(vm.analiticasCarrito[cont].checked){
                    if(vm.analiticasCarrito[cont].tipomuestra_ob_id != null){
                        if(!Array.isArray(vm.analiticasCarrito[cont].tipomuestra_ob_id)){
                            vm.analiticasCarrito[cont].tipomuestra_ob_id = (""+vm.analiticasCarrito[cont].tipomuestra_ob_id).split(",");
                        }
                        var tipoSplit = vm.analiticasCarrito[cont].tipomuestra_ob_id;
                        for(var cont2=0;cont2<tipoSplit.length;cont2++){
                            if(typeof(vm.tiposNecesarias[tipoSplit[cont2]]) == 'undefined'){
                                vm.tiposNecesarias[tipoSplit[cont2]] = { 
                                    disabled: true, 
                                    checked: true, 
                                    nombre : vm.tipoMuestras[tipoSplit[cont2]], 
                                    limps_id: tipoSplit[cont2] 
                                };
                            }else{
                                vm.tiposNecesarias[tipoSplit[cont2]].checked = true;
                                vm.tiposNecesarias[tipoSplit[cont2]].disabled = true;
                            }
                        }
                    }
                    if(vm.analiticasCarrito[cont].tipomuestra_op_id != null){
                        if(!Array.isArray(vm.analiticasCarrito[cont].tipomuestra_op_id)){
                            vm.analiticasCarrito[cont].tipomuestra_op_id = (""+vm.analiticasCarrito[cont].tipomuestra_op_id).split(",");
                        }
                        var tipoSplit = vm.analiticasCarrito[cont].tipomuestra_op_id;
                        for(var cont2=0;cont2<tipoSplit.length;cont2++){
                           if(typeof(vm.tiposNecesarias[tipoSplit[cont2]]) == 'undefined'){
                                vm.tiposNecesarias[tipoSplit[cont2]] = { 
                                    disabled: false, 
                                    checked:false, 
                                    nombre : vm.tipoMuestras[tipoSplit[cont2]], 
                                    limps_id: tipoSplit[cont2] 
                                };
                                if(tipoSplit.length==1){
                                    vm.tiposNecesarias[tipoSplit[cont2]].checked = true;
                                    vm.tiposNecesarias[tipoSplit[cont2]].disabled = true;
                                }
                            }else{
                                //vm.tiposNecesarias[tipoSplit[cont2]].disabled = true;
                                //vm.tiposNecesarias[tipoSplit[cont2]].checked = true;
                            }
                        }
                    }
                    console.log( vm.tiposNecesarias);
                        /*var tipoSplit = vm.analiticasCarrito[cont].tipomuestra_ob_id.split(",");
                        for(var cont2=0;cont2<tipoSplit.length;cont2++){
                            if(typeof(vm.tiposNecesarias[tipoSplit[cont2]]) == 'undefined'){
                                    //console.log(vm.analiticasCarrito[cont].tipomuestra_opcional);
                                vm.tiposNecesarias[tipoSplit[cont2]] = { 
                                    disabled:((tipoSplit.length==1 || vm.analiticasCarrito[cont].tipomuestra_opcional==0 || vm.analiticasCarrito[cont].tipomuestra_opcional==null) ? true : false), 
                                    checked:((tipoSplit.length==1 || vm.analiticasCarrito[cont].tipomuestra_opcional==0 || vm.analiticasCarrito[cont].tipomuestra_opcional==null)? true : false), 
                                    nombre : vm.tipoMuestras[tipoSplit[cont2]], 
                                    limps_id: tipoSplit[cont2] 
                                };
                            }else{
                                if(tipoSplit.length==1 || vm.analiticasCarrito[cont].tipomuestra_opcional==0 || vm.analiticasCarrito[cont].tipomuestra_opcional==null){
                                    vm.tiposNecesarias[tipoSplit[cont2]].disabled = true;
                                    vm.tiposNecesarias[tipoSplit[cont2]].checked = true;
                                }
                            }
                        }
                    }*/
                }
            }
            //console.log(vm.tiposNecesarias);
        }

        if (!Object.entries){
           Object.entries = function( obj ){
              var ownProps = Object.keys( obj ),
                 i = ownProps.length,
                 resArray = new Array(i); // preallocate the Array

              while (i--)
                 resArray[i] = [ownProps[i], obj[ownProps[i]]];
              return resArray;
           };
       }

        vm.muestrasObligatorias = function(){
            var res = 0;
            for(var key in vm.tiposNecesarias){
                if(vm.tiposNecesarias[key].disabled && vm.tiposNecesarias[key].checked){
                    res++;
                }
            }
            /*for(const [key,tipo] of Object.entries(vm.tiposNecesarias)){
                if(tipo.disabled){
                    res++;
                }
            }*/
            return res;
        }

        vm.esEspacio = function(sub){
            var res = false;
            for(var cont=0;cont<vm.tiposAnalisis.length;cont++){
                if(typeof(sub) != 'undefined' && vm.tiposAnalisis[cont].id == sub.categoriaweb_id && vm.tiposAnalisis[cont].espacio=='Otros'){
                    res = true;
                }
            }
            //console.log("Espacio",res);
            return res;
        }

        vm.contarNecesarias = function(){
            var res = vm.muestrasObligatorias();
            var resOpcionales = vm.muestrasOpcionalesComparacionNecesarias();
            return res+resOpcionales;

        }

        vm.muestrasOpcionales = function(){
           var res = 0;
           for(var cont=0;cont<vm.analiticasCarrito.length;cont++){
                if(vm.analiticasCarrito[cont].checked){
                    if(vm.analiticasCarrito[cont].tipomuestra_id != null){
                        var tipoSplit = vm.analiticasCarrito[cont].tipomuestra_id.split(",");
                        if(tipoSplit.length>1){
                            res++;
                        }
                    }
                }
            }
            return res;
        }

        vm.buscarEnNecesarias = function(limps_id){
            var res = false;
            for(var key in vm.tiposNecesarias){
                if(vm.tiposNecesarias[key].disabled && limps_id==vm.tiposNecesarias[key].limps_id){
                    res = true;
                }

            }
            /*for(const [key,tipo] of Object.entries(vm.tiposNecesarias)){
                if(tipo.disabled && limps_id==tipo.limps_id){
                    res = true;
                }
            }*/
            return res;
        }

        vm.muestrasOpcionalesComparacionNecesarias = function(){
           var res = 0;
           for(var cont=0;cont<vm.analiticasCarrito.length;cont++){
                if(vm.analiticasCarrito[cont].checked){
                    if(vm.analiticasCarrito[cont].tipomuestra_op_id != null){
                        var tipoSplit = vm.analiticasCarrito[cont].tipomuestra_op_id;
                        var existeNeces = false;
                        for(var cont2=0;cont2<tipoSplit.length;cont2++){
                            if(vm.buscarEnNecesarias(tipoSplit[cont2])){
                                existeNeces = true;
                            }
                        }
                        if(!existeNeces){
                            res++;
                        }
                    }
                }
            }
            return res;
        }

        vm.getUrlVars = function() {
            var vars = {};
            var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
                vars[key] = value;
            });
            return vars;
        }


        vm.comprobarParams = function(){
            //var url_string = $window.location.href; 
            //var url = new URL(url_string);
            vm.params = vm.getUrlVars();
            vm.paramsExtra = vm.params;
            if(typeof(vm.paramsExtra.grupocompra_id) == 'undefined'){
                vm.paramsExtra.grupocompra_id = false;
            }
            if(typeof(vm.paramsExtra.acuerdocomercial_id) == 'undefined'){
                vm.paramsExtra.acuerdocomercial_id = false;
            }
            console.log(vm.paramsExtra);

            //console.log(vm.params);
            //console.log(vm.params);
            if(typeof(vm.params["amuestra"])!='undefined'){
                vm.loadingParams = true;
            }else if(typeof(vm.params["rmuestra"])!='undefined'){
                vm.loadingParams = true;
                vm.tipoAnalisis=3;
            }else if(typeof(vm.params["animal"])!='undefined'){
                vm.loadingParams = true;
            }else if(typeof(vm.params["recom"])!='undefined'){
                vm.loadingParams = true;
            }
            if(vm.params.reference=='animal' && !vm.params.reference_id){
                vm.loadingParams = true;
            }
        }

        vm.changeTipoAnalisis = function(type){
            if(type!=vm.tipoAnalisis){
                vm.muestraSeleccionada = {};
            }
            vm.tipoAnalisis = type;
            vm.comenzarAnalitica = false;
            vm.paso = 1;

        }

        vm.printPeti = function(){

            var printContents = document.getElementById('petiPrint').innerHTML;
            var ifram = document.createElement("iframe");
            ifram.style = "display:none";
            document.body.appendChild(ifram);
            var pri = ifram.contentWindow;
            pri.document.open();

            pri.document.write("<html><head><title></title></head><body>" + printContents + "</body>");
            pri.document.close();
            pri.focus();
            pri.print();

            /*var printContents = document.getElementById('petiPrint').innerHTML;
             var originalContents = document.body.innerHTML;
             document.body.innerHTML = "<html><head><title></title><link rel='stylesheet' type='text/css' href='http://uranolabweb.loc/css/styleslab.css?v=1.6'></head><body>" + printContents + "</body>";
             window.print();
             document.body.innerHTML = originalContents;*/
        }


        vm.seleccionarAnimal = function(animal,callback){
            //console.log(animal);
            vm.loadingPacientes = true;
            animal.centro_id = vm.fields.centro_id;
            AnimalesService.getMuestrasByAnimal(animal,function(data){
                vm.animalSeleccionado = animal;
                vm.animalSeleccionado.muestras = data.muestras;
                if(angular.isUndefined(animal.especie_id) || !animal.especie_id){
                    vm.newAnimal = animal;
                    vm.changeTipoAnalisis(2);
                }else{
                    vm.paso = 2;
                    vm.loadingPacientes = false;
                    if(typeof(callback)!='undefined'){
                        callback(data);
                    }
                }
            });

        }

        vm.cambiarCentroAdmin = function(){
            vm.paso = 1;
            vm.newAnimal.centro = vm.filtrosPaciente.centro;
            vm.filtrosMuestra.centro = vm.filtrosPaciente.centro;
            if(vm.tipoAnalisis==1){
                vm.getPacientes(0);
            }
            if(vm.tipoAnalisis==3){
                vm.getMuestras();
            }
            if(vm.filtrosPaciente.centro!=""){
                vm.generalLab.optionsCentros.initSelection = function (element, callback) {
                    callback({id: vm.filtrosPaciente.centro, text: $('#filtrocentro option:selected').text() });
                };
            }
            
        }

        vm.nextPagePacientes = function(){
            vm.filtrosPaciente.page++;
        }

        vm.contieneTipoAnalitica = function(analiticas_ids,tipo_id){
            var res = false;
            //console.log(analiticas_ids);
            //console.log(tipo_id);

            if(analiticas_ids!=null && analiticas_ids!=0){
                var analiticasSplit = analiticas_ids.split(",");
                if(analiticasSplit.length>0){
                    for(var cont=0;cont<analiticasSplit.length && !res;cont++){
                        if(analiticasSplit[cont]==tipo_id){
                            res = true;
                        }
                    }
                }
            }
            return res;
            //console.log(analiticas_ids);

        }

        vm.initPet = function(peticion_id){
            //SOLO PARA EDITAR
            console.log("INIT");
            //if(vm.fields.peticion_id){
                AnalisisService.getMuestaAnimalYMuestras(peticion_id,function(data){
                    //AnimalesService.getAnimalByMuestra(data.muestra,function(subdata){
                    if(data.animal){
                        //data.muestra
                        vm.fields = data.muestra;
                        vm.animalSeleccionado = data.animal;
                        vm.analiticasCarrito = data.carrito;
                        vm.paso = 4;
                        vm.loadingParams = false;
                        console.log(vm.analiticasCarrito);
                        //vm.animalSeleccionado.muestras = data.muestras;
                        vm.getTiposMuestraNecesarias();//REVISAR

                        for(var cont = 0;cont<data.muestra.tipomuestra_id.length;cont++){
                            if(vm.tiposNecesarias[data.muestra.tipomuestra_id[cont]]){
                                vm.tiposNecesarias[data.muestra.tipomuestra_id[cont]].checked=true;
                            }
                        }
                    }
                    //vm.replicarMuestra(data.muestra)

                    //});
                });
            //}
        }
        vm.replicarMuestra = function(muestra){
            //REVISAR TODA LA FUNCION UNA VEZ SE SINCRONICE
            //vm.analiticasCarrito = [];
            //vm.muestraSeleccionada = {};
            /*var idsSeleccionadas = [];
            for(var cont=0;cont<muestra.analiticas.length;cont++){
                for(var cont2=0;cont2<muestra.analiticas[cont].analiticas.length;cont2++){
                    var resultado = vm.buscarAnalitica(muestra.analiticas[cont].analiticas[cont2]);
                    if(resultado){
                        resultado.checked = true;
                        if(idsSeleccionadas.indexOf(resultado.id_sql) == -1) {
                            vm.analiticasCarrito.push(resultado);
                            idsSeleccionadas.push(resultado.id_sql);
                        }
                    }
                }
            }*/
            //vm.paso = 4;
            //vm.loadingParams = false;
            //vm.getTiposMuestraNecesarias();//REVISAR

        }

        vm.modalSelAnimal = "";
        vm.vieneParam = function(){
            //vm.comprobarParams();
            console.log(vm.params);


            
            if(typeof(vm.params["amuestra"]) != 'undefined'){
                vm.tipoAnalisis=3;
                AnalisisService.getAnaliticaByMuestraId(vm.params["amuestra"],function(data){
                    vm.anadirMuestra(data.muestra)
                });
            }else if(typeof(vm.params["rmuestra"]) != 'undefined'){
                //vm.tipoAnalisis=3;
                AnalisisService.getAnaliticaByMuestraId(vm.params["rmuestra"],function(data){
                    AnimalesService.getAnimalByMuestra(data.muestra,function(subdata){
                        if(subdata.animal){
                            vm.animalSeleccionado = subdata.animal;
                            vm.animalSeleccionado.muestras = subdata.muestras;
                        }
                        vm.repetirMuestra(data.muestra);

                    });
                });
            }else if(typeof(vm.params["recom"]) != 'undefined'){
                //vm.tipoAnalisis=3;
                AnalisisService.getAnaliticaByRecomendacion(vm.params["recom"],function(data){
                    var muestra = angular.copy(data.peticion);
                    muestra.analiticas = [];
                    for(var cont = 0;cont< data.analiticas.length;cont++){
                        muestra.analiticas.push({analitica_id:data.analiticas[cont]});
                    }
                    console.log("analiticas",muestra);
                    /*AnimalesService.getAnimalByMuestra(muestra,function(subdata){
                        if(subdata.animal){
                            vm.animalSeleccionado = subdata.animal;
                            vm.animalSeleccionado.muestras = subdata.muestras;
                        }
                        vm.repetirMuestra(muestra);
                        vm.recomendacion = vm.params["recom"];

                    });*/
                    console.log("datapeticion",data.peticion);
                    vm.anadirMuestra(data.peticion,function(){
                        vm.repetirMuestra(muestra);
                        vm.recomendacion = vm.params["recom"];
                    });
                });
            }else if(typeof(vm.params["htvet"]) != 'undefined'){
                var carritoSimp = [];
                


                carritoSimp.push({
                    id:vm.params["htvet"],
                    precio:0,
                    checked:true,
                    descuento:0,
                    codigo:'',
                    extra:''
                });
                var muestra = { id : vm.params["pet_rel_id"], animal_id : vm.params["animal_id"] };
                AnimalesService.getAnimalByMuestra(muestra,function(data){
                    if(data.animal){
                        vm.animalSeleccionado = data.animal;
                        vm.animalSeleccionado.muestras = data.muestras.muestras;
                        vm.comenzar();
                        
                    }
                    AnalisisService.getAnaliticasCategoria(carritoSimp,vm.animalSeleccionado,'','','','',vm.paramsExtra,function(data){
                        vm.analiticasCarrito = data.analiticasCarrito;  
                        for(var cont=0;cont<vm.analiticasCarrito.length;cont++){
                            vm.analiticasCarrito[cont].checked=true;
                        }
                        vm.reglasActivas = data.reglas;
                        vm.getTiposMuestraNecesarias();
                        console.log(vm.animalSeleccionado);
                        if(vm.animalSeleccionado){
                            vm.paso = 4;
                        }else{
                            vm.paso = 1;
                        }
                        vm.loadingParams = false;
                        //onsole.log(vm.reglasActivas);
                        //vm.reglasActivas = data.reglas;
                        //vm.getReglas();
                    });
                    
                });
                

               
            }else if(typeof(vm.params["animal"]) != 'undefined'){
                vm.filtrosPaciente.id = vm.params["animal"];
                vm.getPacientes(0,function(data){
                    if(data.animales.length==1){
                        vm.seleccionarAnimal(data.animales[0],function(dataanim){
                            vm.muestraSeleccionada = {};
                            vm.comenzar();
                            console.log("searchrel",vm.params["visita_id"]);
                            if(typeof(vm.params["visita_id"]) != 'undefined'){
                                AnimalesService.buscarAnimalesRel(vm.filtrosPaciente.id,function(dataanimal){
                                    if(dataanimal.animalesRel.length>0){
                                        vm.modalSelAnimal = $uibModal.open({
                                              animation: true,
                                              ariaLabelledBy: 'modal-title-top',
                                              ariaDescribedBy: 'modal-body-top',
                                              templateUrl: 'searchrel.html',
                                              size: 'right',
                                              //class: 'txt-center',
                                              backdrop:'static',
                                              controller: function($scope) {
                                                $scope.relacionados = dataanimal.animalesRel;
                                                $scope.monedero = vm.generalLab.monedero;     
                                                $scope.sumaPet = vm.sumaCarrito();     
                                                $scope.intercambiarAnimal = function(animalSelect){
                                                    AnimalesService.intercambiarAnimal(animalSelect.id,vm.filtrosPaciente.id,function(dataint){
                                                        vm.seleccionarAnimal(animalSelect,function(dataanim){
                                                            vm.muestraSeleccionada = {};
                                                            vm.comenzar();
                                                            vm.modalSelAnimal.close();
                                                        });
                                                    });
                                                }
                                                $scope.koForm = function(){
                                                    vm.modalSelAnimal.close();
                                                }
                                              }
                                          });
                                    }
                                });
                            }
                        });
                    }
                });
                vm.loadingParams = false;
            }
            if(vm.params.reference=='animal' && vm.params.reference_id){
                console.log("E");
                vm.filtrosPaciente.id = vm.params.reference_id;
                vm.getPacientes(0);
                vm.loadingParams = false;
            }

        }
        vm.getAnimalesCentro = function(){
            vm.loadingPacientes = true;
            vm.loadingMuestras = true;
            vm.comprobarParams();
                AnimalesService.getAnaliticas(vm.fields,function(data){
                    vm.vieneParam();
                    vm.analiticas = data.analiticas;
                    vm.tipoMuestras = data.tiposMuestra;
                    vm.tiposAnalisis = data.tiposAnalisis;
                    vm.loadingMuestras = false;
                    if(data.popup){
                        vm.abrirInfoSJ(data.popup);
                    }
                    //vm.init();
                });
        }

        

        vm.selectEspecie = function(especie){
            vm.newAnimal.categoriaespecie_id = especie.id;
        }

        vm.volverAtras = function(paso){
            if(paso==3){
                vm.comenzar();
            }else{
                paso = paso;
            }
        }

        vm.comenzar = function(){
            
            vm.comenzarAnalitica = true;
            vm.paso = 3;
            $timeout(function(){
                $("html, body").animate({ scrollTop: $('.sel_analysis').offset().top }, 1000);
            })
        }

        vm.getCarritoSimplificado = function(){
            var carritoSimplificado = [];
            console.log(vm.analiticasCarrito[cont]);
            for(var cont=0;cont<vm.analiticasCarrito.length;cont++){
                //console.log(vm.analiticasCarrito[cont]);
                if(vm.analiticasCarrito[cont].checked){
                    carritoSimplificado.push({
                        id:vm.analiticasCarrito[cont].id,
                        precio:vm.analiticasCarrito[cont].precio,
                        descuento:vm.analiticasCarrito[cont].descuento,
                        codigo:(vm.analiticasCarrito[cont].codigo ? vm.analiticasCarrito[cont].codigo : ''),
                        extra:JSON.stringify(vm.analiticasCarrito[cont].extra)
                    });
                }
            }
            return carritoSimplificado;
        }

        vm.getCarritoLarge = function(){
            var carritoSimplificado = [];
            for(var cont=0;cont<vm.analiticasCarrito.length;cont++){
                //console.log(vm.analiticasCarrito[cont]);
                carritoSimplificado.push({
                    id:vm.analiticasCarrito[cont].id,
                    precio:vm.analiticasCarrito[cont].precio,
                    checked:vm.analiticasCarrito[cont].checked,
                    descuento:vm.analiticasCarrito[cont].descuento,
                    codigo:(vm.analiticasCarrito[cont].codigo ? vm.analiticasCarrito[cont].codigo : ''),
                    extra:JSON.stringify(vm.analiticasCarrito[cont].extra)
                });
            }
            return carritoSimplificado;
        }

        vm.estanTodasMuestrasNecesarias = function(){
            var res = true;
            for(var cont=0;cont<vm.analiticasCarrito.length && res;cont++){
                if(vm.analiticasCarrito[cont].checked && vm.analiticasCarrito[cont].tipomuestra_op_id!=null){
                    var tipos = vm.analiticasCarrito[cont].tipomuestra_op_id;
                    //console.log(tipos.length);
                    //console.log(vm.analiticasCarrito[cont]);
                    if(tipos.length>1 && vm.analiticasCarrito[cont].tipomuestra_op_id.length>1){
                        var resAnalitica = false;
                        //console.log(tipos.length);
                        for(var cont2=0;cont2<tipos.length;cont2++){
                            //console.log(vm.tiposNecesarias[tipos[cont2]]);
                            if(vm.tiposNecesarias[tipos[cont2]].checked){
                                resAnalitica = true;
                            }
                        }
                        if(!resAnalitica){
                            res = false;
                        }
                    }
                }
            }
            return res;
        }

        vm.barcode;
        vm.modalMonedero = "";
        vm.enviarPeticionAnalisis = function(form){
            if (!form.$valid) {
                console.log("no valid",angular.element("[name='" + form.$name + "']").find('.ng-invalid:visible:first'));
                angular.element("[name='" + form.$name + "']").find('.ng-invalid:visible:first').focus();
                return false;
            }
            if(vm.generalLab.monedero>0 && (vm.fields.monedero!=0 && vm.fields.monedero!=1)){
                 vm.modalMonedero = $uibModal.open({
                  animation: true,
                  ariaLabelledBy: 'modal-title-top',
                  ariaDescribedBy: 'modal-body-top',
                  templateUrl: 'monedero.html',
                  size: 'sm',
                  class: 'txt-center',
                  backdrop:'static',
                  controller: function($scope) {
                    $scope.monedero = vm.generalLab.monedero;     
                    $scope.sumaPet = vm.sumaCarrito();     
                    $scope.okForm = function(value){
                       
                        vm.fields.monedero = value;   
                        vm.modalMonedero.close();
                        vm.enviarPeticionAnalisis(form);
                    }
                    $scope.koForm = function(){
                        vm.modalMonedero.close();
                    }
                   
                  }
              });
                return false;
            }
            if(!vm.estanTodasMuestrasNecesarias() && !vm.muestraSeleccionada.id){
                return false;
            }
            vm.loadingSave = true;
            AnalisisService.guardarPeticion(vm.getCarritoSimplificado(),vm.fields,vm.tiposNecesarias,vm.animalSeleccionado.id,vm.muestraSeleccionada.id,vm.paramsExtra,function(data){
                if(data.code==1){
                    vm.paso = 5;
                    vm.loadingSave = false;
                    vm.barcode = data.barcode;
                    vm.peticion_id = data.muestra_id;
                    if(data.monedero){
                        vm.generalLab.monedero = data.monedero;
                    }
                    /*$analytics.eventTrack("peticion-ret-ok", {
                      category: 'form peticion', label: 'peticion creada con exito', value : Math.floor(vm.sumaCarrito())
                    });*/
                }else{
                    vm.paso = 'error';
                    /*$analytics.eventTrack("peticion-ret-ko", {
                      category: 'form peticion', label: 'ERROR peticion no creada '+JSON.stringify(data.msg), value:Math.floor(vm.sumaCarrito())
                    });*/
                }
            });
        }

        vm.tieneCat = function(cat){
            var res = false;
            for(var cont=0;cont<vm.tiposAnalisis.length && !res;cont++){
                if(vm.tiposAnalisis[cont].espacio==cat){
                    res = true;
                }
            }
            return res;
        }


        vm.guardarpaciente = function(){
            vm.loadingPaciente = true;
            vm.newAnimal.centro_id = vm.fields.centro_id;
            AnimalesService.guardarPaciente(vm.newAnimal,function(data){
               
                if(data.code==1){
                    $timeout(function(){
                        vm.animalSeleccionado = data.nuevoAnimal;
                        vm.animalSeleccionado.muestras = [];
                        vm.newAnimal = {};
                        vm.comenzar();
                        vm.loadingPaciente = false;
                    })
                    /*$analytics.eventTrack('REQUEST ANIMAL OK', {
                      category: 'form new paciente', label: 'Paciente creado con exito'
                    });*/
                }else{
                    /*$analytics.eventTrack('REQUEST ANIMAL KO', {
                      category: 'form new paciente', label: 'ERROR Paciente no creado'
                    });*/
                }
                
            });
        }

        vm.contieneTipoSeleccionado = function(id){
            //return true;
            var res = false;
            for(var cont=0;cont<vm.tipoSeleccionado.length && !res;cont++){
                if(vm.tipoSeleccionado[cont]==id){
                    res = true;
                }
            }
            return res;
        }

        vm.contieneCategoriaespecie = function(subtipo){
            //console.log(subtipo);
            if(typeof(subtipo.categoriaespecie_id)!='undefined' && subtipo.categoriaespecie_id != null){
                if(!Array.isArray(subtipo.categoriaespecie_id)){
                    subtipo.categoriaespecie_id = ''+subtipo.categoriaespecie_id;
                    subtipo.categoriaespecie_id = subtipo.categoriaespecie_id.split(",");
                }
                var res = false;
                for(var cont=0;cont<subtipo.categoriaespecie_id.length && !res;cont++){
                    if(vm.animalSeleccionado.categoriaespecie == subtipo.categoriaespecie_id[cont]){
                        res = true;
                    }
                }
                return res;
            }else{
                return true;
            }
            //if(subtipo.categoriaespecie_id
        }

        vm.contieneAnaliticaespecie = function(analitica){
             if(typeof(analitica.categoriaespecie_id)!='undefined' && analitica.categoriaespecie_id != null && analitica.categoriaespecie_id != 0){
                if(!Array.isArray(analitica.categoriaespecie_id)){
                    analitica.categoriaespecie_id = ''+analitica.categoriaespecie_id;
                    analitica.categoriaespecie_id = analitica.categoriaespecie_id.split(",");
                }
                var res = false;
                for(var cont=0;cont<analitica.categoriaespecie_id.length && !res;cont++){
                    if(vm.animalSeleccionado.categoriaespecie == analitica.categoriaespecie_id[cont]){
                        res = true;
                    }
                }
                return res;
            }else{
                return true;
            }
        }

        vm.contieneTipo = function(tipoData,tipo_id){
            var res = false;
            if(tipoData != null){
                //console.log(tipoData);
                tipoData = tipoData.split(",");
                if(tipoData.indexOf(tipo_id) == -1) {
                  res = true;
                }
            }
            return res;
        }

        vm.accentFold = function(inStr) {
          return inStr.replace(
            /([àáâãäåÁÀ])|([çčć])|([èéêëÉÈ])|([ìíîïÍ])|([ñ])|([òóôõöøÓÒ])|([ß])|([ùúûüÚÙÜ])|([ÿ])|([æ])/g, 
            function (str, a, c, e, i, n, o, s, u, y, ae) {
              if (a) return 'a';
              if (c) return 'c';
              if (e) return 'e';
              if (i) return 'i';
              if (n) return 'n';
              if (o) return 'o';
              if (s) return 's';
              if (u) return 'u';
              if (y) return 'y';
              if (ae) return 'ae';
            }
          );
        }

        function removeAccents(value) {
            return value
                .replace(/á/g, 'a')            
                .replace(/à/g, 'a')            
                .replace(/é/g, 'e')
                .replace(/è/g, 'e')
                .replace(/í/g, 'i')
                .replace(/ï/g, 'i')
                .replace(/ó/g, 'o')
                .replace(/ò/g, 'o')
                .replace(/ú/g, 'u')
                .replace(/ü/g, 'u');
        }
        if (!('contains' in String.prototype)) {
            String.prototype.contains = function (str, startIndex) {
                "use strict";
                return -1 !== String.prototype.indexOf.call(this, str, startIndex);
            };
        }

        vm.filterTipos = function(item, tipoIndex){
            //console.log(tipoIndex);
            if (vm.buscador.nombre){
                if(tipoIndex==0){
                    return true;
                }else{
                    return false;
                }
            }
            return (item.categoriaanalitica_id && vm.contieneTipoSeleccionado(item.categoriaanalitica_id) && vm.contieneBuscador(item) && vm.contieneCategoriaespecie(item));
        }

        vm.filterAnaliticasAccents = function(subtipo) {   
            return function(item) {
                if (!vm.buscador.nombre){
                    //return true;
                    return (/*vm.contieneTipoAnalitica(item.categoriaanalitica_id,subtipo.id) &&*/ vm.contieneAnaliticaespecie(item));
                }

                var text = removeAccents(item.nombre.toLowerCase()+(item.nombre_web != null && item.nombre_web!='' ? " "+item.nombre_web.toLowerCase() :''));
                var search = removeAccents(vm.buscador.nombre.toLowerCase());
                
                return (text.indexOf(search) != -1);
           }
           
        };

        vm.contieneBuscador = function(subtipo){
            var res = true;
            if(vm.buscador.nombre!=""){
                res = false;
                angular.forEach(vm.analiticas,function(data){
                    //console.log(data.categoriaanalitica_id);
                    //var re = new RegExp(vm.buscador.nombre, 'i');
                    var text = removeAccents(data.nombre.toLowerCase()+(data.nombre_web != null && data.nombre_web!='' ? " "+data.nombre_web.toLowerCase() :''));
                    var search = removeAccents(vm.buscador.nombre.toLowerCase());
                    if(/*data.nombre.indexOf(vm.buscador.nombre) > -1*/text.indexOf(search) && vm.contieneTipo(data.categoriaanalitica_id,subtipo.id)){
                        //console.log(data.nombre);
                        res = true;
                    }
               })
            }
            return res;
        }

        vm.existeVisibleanalitica = function(analitica){
            var res = false;
            for(var cont=0;cont<vm.subcategorias.length && !res;cont++){
                if(typeof(vm.subcategorias[cont].visible_analitica_id)!='undefined'){
                    vm.subcategorias[cont].visible_analitica_id = ''+vm.subcategorias[cont].visible_analitica_id;
                    if(vm.subcategorias[cont].visible_analitica_id.split(",").indexOf(''+analitica.id)!==-1){
                        res = true;
                    }
                }
            }
            return res;
        }
        vm.buscadorAnaliticas = function(tipo){
            if(!tipo){
                vm.tipoSeleccionado = [];
            }
            vm.loadingAnaliticas = true;
            if(!tipo){
                if(vm.buscador.nombre==""){
                    var res = false;
                    for(var cont=0;cont < vm.tiposAnalisis.length  && !res;cont++){
                        if(typeof(vm.tiposAnalisis[cont].categoriaanalitica_id)=='undefined' || vm.tiposAnalisis[cont].categoriaanalitica_id==0){
                            vm.tipoSeleccionado = [vm.tiposAnalisis[cont].id];
                            res = true;
                        }
                    }
                }else{
                    var res = false;
                    for(var cont=0;cont < vm.tiposAnalisis.length ;cont++){
                        if(typeof(vm.tiposAnalisis[cont].categoriaanalitica_id)=='undefined' || vm.tiposAnalisis[cont].categoriaanalitica_id==0){
                            vm.tipoSeleccionado.push(vm.tiposAnalisis[cont].id);
                        }
                    }
                    //console.log(vm.tipoSeleccionado);
                }
            }
            AnalisisService.getAnaliticasCategoria(vm.getCarritoLarge(),vm.animalSeleccionado,vm.tipoSeleccionado,vm.buscador.nombre,vm.fields.centro_id,vm.muestraSeleccionada,vm.paramsExtra,function(data){
                vm.loadingAnaliticas = false;
                vm.analiticas = data.analiticas;
                vm.subcategorias = data.subcategorias;
                if(data.analiticasCarrito){
                    for(var cont = 0;cont<data.analiticasCarrito.length;cont++){
                        var existeCarrito = vm.existeCarrito(data.analiticasCarrito[cont]);
                        if(existeCarrito && data.analiticasCarrito[cont].reemplazar){
                            existeCarrito.descuento = data.analiticasCarrito[cont].descuento;
                        }
                        //vm.cambiarDescuentoAnalitica(data.analiticasCarrito[cont]);
                    } 
                    //COMENTADO PARA QUE NO CAMBIE EL DESCUENTO DEL CARRITO EN EL CASO DE TENER VARIOS ACUERDOS
                     
                }
                vm.reglasActivas = data.reglas;
                vm.ponerCarritoTarifaCero();
                if(vm.paso==4){
                    console.log("GETTRANS");
                    vm.getTransporte();
                }
            });
            
        }

       vm.getMaterial = function(material_id){
           MaterialesService.getMaterialById(material_id,function(data){
               vm.materialId[material_id] = data.material;
               console.log("material",data);
           })
       }

        vm.tieneCategoriaEspecifica = function(cat_id){

            var res = false;
            for(var cont=0;cont<vm.analiticasCarrito.length && !res;cont++){
                if(vm.analiticasCarrito[cont].categoriaanalitica_id==cat_id){
                    res = true;
                }
            }
            return res;
        }

        

        vm.seleccionarTipoAnalitica = function(tipo,grupocompra,acuerdocomercia_id){
            //console.log(tipo);
            if(!grupocompra){
                vm.paramsExtra.grupocompra_id = false;
            }
            if(!acuerdocomercia_id){
                vm.paramsExtra.acuerdocomercial_id = false;
            }
            vm.tipoSeleccionado = [tipo.id];
            vm.buscador.nombre = "";
            vm.loadingAnaliticas = true;
            console.log("grupo",vm.paramsExtra.grupocompra_id);
            AnalisisService.getAnaliticasCategoria(vm.getCarritoLarge(),vm.animalSeleccionado,vm.tipoSeleccionado,"",vm.fields.centro_id,vm.muestraSeleccionada,vm.paramsExtra,function(data){
                vm.loadingAnaliticas = false;
                vm.analiticas = data.analiticas;
                vm.subcategorias = data.subcategorias;
            });
            //console.log(vm.tipoSeleccionado);
        }

        vm.resumenFinal = function(){
            vm.paso=4;
        }

        vm.existeCarrito = function(analitica){
            var res = false;
            for(var cont=0;cont<vm.analiticasCarrito.length && !res;cont++){
                if(vm.analiticasCarrito[cont].id==analitica.id){
                    res = vm.analiticasCarrito[cont];
                }
            }
            return res;
        }

        vm.getTransporte = function(){
            AnalisisService.getTransporte(vm.sumaCarrito(),function(data){
                vm.transporteEstimado = data.precioEstimado;
            });
        }

        vm.existeCarritoChecked = function(analitica){
            var res = false;
            for(var cont=0;cont<vm.analiticasCarrito.length && !res;cont++){
                if(vm.analiticasCarrito[cont].id==analitica.id && vm.analiticasCarrito[cont].checked){
                    res = vm.analiticasCarrito[cont];
                }
            }
            return res;
        }


        vm.sumaCarrito = function(){
            var suma = 0;
            for(var cont=0;cont<vm.analiticasCarrito.length;cont++){
                if(vm.analiticasCarrito[cont].checked){
                    if(vm.analiticasCarrito[cont].descuento){
                        suma+=parseFloat(vm.analiticasCarrito[cont].precio-((vm.analiticasCarrito[cont].precio*vm.analiticasCarrito[cont].descuento)/100));
                    }else{
                        suma+=parseFloat(vm.analiticasCarrito[cont].precio);
                    }
                }
            }
            return parseFloat(suma).toFixed(2);
        }

        vm.getPacientes = function(page,callback){
            console.log("page",page);
            if(typeof(page)!='undefined'){
                vm.filtrosPaciente.page = page;
            }
            vm.loadingPacientes = true;
            AnimalesService.getAnimalesCentro(vm.fields,vm.filtrosPaciente,function(data){
                vm.loadingPacientes = false;


                if(typeof(page)!='undefined'){

                    $timeout(function(){
                        $('.animaltable').scrollTop(0);
                        vm.animalesCentro = data.animales;
                    });
                }else{
                    vm.animalesCentro = vm.animalesCentro.concat(data.animales);
                }

                if(typeof(callback)!='undefined'){
                    callback(data);
                }
            });
        }

        vm.getMuestras = function(){
            vm.loadingMuestras = true;
            vm.filtrosMuestra.showanaliticas = true;
            AnalisisService.getHistAnalisisCentro(vm.filtrosMuestra,function(data){
                vm.loadingMuestras = false;
                vm.analisis = data.analisis;
            });
        }

        vm.buscarAnalitica = function(analitica){
            var res = false;
            for(var cont=0;cont<vm.analiticas.length && !res;cont++){
                if(vm.analiticas[cont].id==analitica.id){
                    res = vm.analiticas[cont];
                }
            }
            return res;
        }

        vm.buscarAnaliticaById = function(id_analitica){
            var res = false;
            for(var cont=0;cont<vm.analiticas.length && !res;cont++){
                if(vm.analiticas[cont].id==id_analitica){
                    res = vm.analiticas[cont];
                }
            }
            return res;
        }

        /*vm.desactivarAnaliticaByIdAlt = function(analitica_idAlt) {
            var res = false;
            for(var cont=0;cont<vm.analiticas.length && !res;cont++){
                if(vm.analiticas[cont].id==analitica_idAlt){
                    vm.analiticas[cont].disabled = true;
                    res = true;
                }
            }
            return res;
        }*/

        vm.desactivarDelCarrito = function(idsDesactivar){
            var res = false;
            for(var cont=0;cont<idsDesactivar.length && !res;cont++){
                res = false;
                for(var cont2=0;cont2<vm.analiticasCarrito.length && !res;cont2++){
                    if(vm.analiticasCarrito[cont2].checked){
                        if(idsDesactivar[cont]==vm.analiticasCarrito[cont2].id){
                            vm.analiticasCarrito[cont2].checked = false;
                            vm.getTiposMuestraNecesarias();
                        }
                    }
                }
            }

        }
        vm.desactivarAnaliticas = function(analitica){
            //console.log(analitica);
            var res = false;
            for(var cont=0;cont<vm.analiticasCarrito.length && !res;cont++){
                //console.log(vm.analiticasCarrito[cont].grupoanaliticas_id);
                if(vm.analiticasCarrito[cont].checked && vm.analiticasCarrito[cont].grupoanaliticas_id!=null){
                   //console.log("NULL");
                   var splitGrupo = vm.analiticasCarrito[cont].grupoanaliticas_id.split(",");
                   //console.log(splitGrupo);
                   vm.desactivarDelCarrito(splitGrupo);
                   for(var cont2=0;cont2<splitGrupo.length && !res;cont2++){
                       //console.log(splitGrupo[cont2]);
                       //console.log(vm.analiticasCarrito[cont].id);
                       if(splitGrupo[cont2]==analitica.id){
                           //analitica.checked=false;
                           //console.log("asd");
                           res = true;
                       }
                   }
                }
                //console.log(vm.analiticasCarrito[cont].grupoanaliticas_id);
            }
            return res;
            //vm.desactivarAnaliticaByIdAlt(vm.analiticasSplit[cont]);
            //analitica.grupoanaliticas_id
        }

        /*vm.desactivarAnaliticas = function(analiticasjoin){
            var analiticasSplit = analiticasjoin.split(",");
            for(var cont=0;cont<vm.analiticasSplit.length;cont++){
                vm.desactivarAnaliticaByIdAlt(vm.analiticasSplit[cont]);
            }
        }
        vm.bloquearAnaliticasPerfiles = function(){
            var res = false;
            for(var cont=0;cont<vm.analiticasCarrito.length;cont++){
                if(vm.analiticasCarrito[cont].checked){
                    if(vm.analiticasCarrito[cont].grupoanaliticas_id!=null){
                        vm.desactivarAnaliticas(vm.analiticasCarrito[cont].grupoanaliticas_id);
                    }
                }
                //console.log(vm.analiticasCarrito[cont].grupoanaliticas_id);
            }
            return res;
        }*/


        vm.contieneMuestra = function(analitica){
            //console.log(analitica);
            if(!vm.muestraSeleccionada.id){
                return true;
            }
            var res = false;
            //console.log(vm.muestraSeleccionada);
            var tipoMuestra = vm.muestraSeleccionada.tipomuestra_id;
            var tipoMuestraAnal = [];
            if(analitica.tipomuestra_op_id!=null){
                tipoMuestraAnal = analitica.tipomuestra_op_id.split(",");
            }
            if(analitica.tipomuestra_ob_id!=null){
                tipoMuestraAnal = tipoMuestraAnal.concat(analitica.tipomuestra_ob_id);
            }
            //console.log(tipoMuestra);
            //console.log(tipoMuestraAnal);
            if(!Array.isArray(tipoMuestra)){
                tipoMuestra = tipoMuestra.toString().split(",");
            }
            for(var cont=0;cont<tipoMuestra.length && !res;cont++){
                for(var cont2=0;cont2<tipoMuestraAnal.length && !res;cont2++){
                    if(tipoMuestra[cont]==tipoMuestraAnal[cont2]){
                        res = true;
                    }
                }
            }
            if(res){
                //COMPROBAMOS QUE NO ESTE ESA PRUEBA EN LA PADRE
                for(var cont = 0;cont<vm.muestraSeleccionada.analiticas.length && res;cont++){
                    for(var cont2 = 0;cont2<vm.muestraSeleccionada.analiticas[cont].analiticas.length && res;cont2++){
                        if(vm.muestraSeleccionada.analiticas[cont].analiticas[cont2].id==analitica.id){
                            res = false;
                        }
                    }
                }
            }
            //console.log(res);
            return res;
        }

        vm.repetirMuestra = function(muestra){
            vm.analiticasCarrito = [];
            //vm.muestraSeleccionada = {};
            var idsSeleccionadas = [];
            var carritoSimp = [];
            for(var cont=0;cont<muestra.analiticas.length;cont++){
                //for(var cont2=0;cont2<muestra.analiticas[cont].analiticas.length;cont2++){
                    /*var resultado = vm.buscarAnalitica(muestra.analiticas[cont]);
                    if(resultado){
                        resultado.checked = true;
                        if(idsSeleccionadas.indexOf(resultado.id_sql) == -1) {
                            vm.analiticasCarrito.push(resultado);
                            idsSeleccionadas.push(resultado.id_sql);
                        }
                    }*/
                //}
                carritoSimp.push({
                    id:muestra.analiticas[cont].analitica_id,
                    precio:0,
                    checked:true,
                    descuento:0,
                    codigo:'',
                    extra:''
                });

            }
            AnalisisService.getAnaliticasCategoria(carritoSimp,vm.animalSeleccionado,'','','','','',function(data){
                vm.analiticasCarrito = data.analiticasCarrito;  
                for(var cont=0;cont<vm.analiticasCarrito.length;cont++){
                    vm.analiticasCarrito[cont].checked=true;
                }
                vm.reglasActivas = data.reglas;
                vm.getTiposMuestraNecesarias();
                vm.paso = 4;
                vm.loadingParams = false;
                console.log(vm.reglasActivas);
                vm.reglasActivas = data.reglas;
                vm.getReglas();
            });
            //console.log(vm.analiticasCarrito);
            
            
            //vm.getTiposMuestraNecesarias();
            console.log("REPITIENDO");
            //vm.initPet(muestra.id);

        }

        vm.borrarAnaliticaCarrito = function(analitica){
            var res = false;
            for(var cont=0;cont<vm.analiticasCarrito.length && !res;cont++){
                if(vm.analiticasCarrito[cont].id==analitica.id){
                    vm.analiticasCarrito.splice(cont,1);
                    res = true;
                }
            }
        }

        vm.anadirMuestra = function(muestra,callback){
            vm.muestraSeleccionada = muestra;
            /*
            DEBERIAMOS PONER LOS TIPOS DE MUESTRA DE ESA PETICION
            if(typeof(muestra.tipomuestra_id) !='undefined'){
                for(var cont = 0;cont<muestra.tipomuestra_id.length;cont++){
                    
                }
            }*/
                vm.loadingMuestra = true;
            //console.log(muestra);
            AnimalesService.getAnimalByMuestra(muestra,function(data){
                if(data.animal){
                    vm.animalSeleccionado = data.animal;
                    vm.animalSeleccionado.muestras = data.muestras.muestras;
                    vm.comenzar();
                    
                }
                vm.loadingMuestra = false;
                vm.loadingParams = false;
                if(typeof(callback)!='undefined'){
                    callback();
                }
            });
        }

        vm.yearsDiff = function(d1, d2) {
            let date1 = new Date(d1);
            let date2 = new Date(d2);
            let yearsDiff =  date2.getFullYear() - date1.getFullYear();
            return yearsDiff;
        }

        vm.monthsDiff = function(d1, d2) {
          let date1 = new Date(d1);
          let date2 = new Date(d2);
          let years = vm.yearsDiff(d1, d2);
          let months =(years * 12) + (date2.getMonth() - date1.getMonth()) ;
          return months;
        }

        vm.hayCarritoSeleccionado = function(){
            var res = false;
            for(var cont=0;cont<vm.analiticasCarrito.length && !res;cont++){
                if(vm.analiticasCarrito[cont].checked){
                    res = true;
                }
            }
            return res;
        }

        vm.ponerCarritoTarifaCero = function(){
            for(var cont = 0;cont<vm.reglasActivas.length;cont++){
                if(vm.reglasActivas[cont].descuento==100 && vm.reglasActivas[cont].poner_automatica /*&& !vm.existeCarrito(vm.reglasActivas[cont].analitica)*/){
                    if(vm.contieneMuestra(vm.reglasActivas[cont].analitica)){
                        var existeCarrito = vm.existeCarrito(vm.reglasActivas[cont].analitica);
                        if(!existeCarrito){
                            vm.reglasActivas[cont].analitica.checked = true;
                            vm.analiticasCarrito.push(vm.reglasActivas[cont].analitica);
                        }else{
                            existeCarrito.checked = true;
                        }
                        vm.getTiposMuestraNecesarias();
                    }
                }
            }
        }

        vm.addInfoMuestra = function(aExtra){
            //console.log(aExtra);
            aExtra.muestras.push({});
        }
        vm.addInfoTumor = function(aExtra){
            aExtra.tumores.push({});

        }

        vm.addTratamiento = function(){
            
            vm.extra.tratamientos.push({tratamiento:"",respuesta:""});
        }

        vm.addProduct = function(){
            vm.extra.productos_tratamiento.push({producto:"",dosis:"","desde":''});

        }

        vm.cambiarDescuentoAnalitica = function(analitica){
            var res = false;
            //console.log(analitica);
            for(var cont=0;cont<vm.analiticas.length;cont++){
                if(vm.analiticas[cont].id==analitica.id){
                    vm.analiticas[cont].descuento = analitica.descuento;
                    res = true;
                }
                if(vm.analiticas[cont].relacionadas){
                    for(var cont2=0;cont2<vm.analiticas[cont].relacionadas.length;cont2++){
                        if(vm.analiticas[cont].relacionadas[cont2].id == analitica.id){
                            vm.analiticas[cont].relacionadas[cont2].descuento = analitica.descuento;
                        }
                    }

                }
            }
        }

        vm.getReglas = function(){
            vm.buscadorAnaliticas(vm.tipoSeleccionado);
            return true;
            var idsCarrito = [];
            for(var cont=0;cont<vm.analiticasCarrito.length;cont++){
                if(vm.analiticasCarrito[cont].checked){
                    idsCarrito.push(vm.analiticasCarrito[cont].id);
                }
            }
            AnalisisService.getReglas(idsCarrito,vm.fields,function(data){
                if(data.analiticasCarrito.length>0){
                    for(var cont = 0;cont<data.analiticasCarrito.length;cont++){
                        var existeCarrito = vm.existeCarrito(data.analiticasCarrito[cont]);
                        if(existeCarrito && data.analiticasCarrito[cont].reemplazar){
                            existeCarrito.descuento = data.analiticasCarrito[cont].descuento;
                        }
                        vm.cambiarDescuentoAnalitica(data.analiticasCarrito[cont]);
                    }
                }
                vm.reglasActivas = data.reglas;
                //vm.ponerCarritoTarifaCero();
                //console.log(data);
            });
        }

        vm.anadirAnaliticaCarrito = function($event,analitica){
            if(analitica.privada_codigo && !analitica.codigo_usado){
                $event.stopPropagation();
                $event.preventDefault();
                //console.log("ENTRA BOX");
                //analitica.checked = true;
                vm.codigoModal = $uibModal.open({
                  animation: true,
                  ariaLabelledBy: 'modal-title-top',
                  ariaDescribedBy: 'modal-body-top',
                  templateUrl: 'codigo.html',
                  size: 'md',
                  backdrop:'static',
                  controller: function($scope) {
                    $scope.loading = false;
                    $scope.errorMsg = false;
                    $scope.analitica = analitica;
                    //console.log(analitica);
                    //console.log(vm.existeCarritoChecked(analitica));
                    $scope.okForm = function(){
                        $scope.loading = true;
                        analitica.codigo = $scope.codigo;
                        CodigosService.getCodigoAnalitica(analitica,function(data){
                            $scope.loading = false;
                            $scope.code = data.code;
                            $scope.msg = data.msg;
                            if(data.code==1){
                                analitica.codigo_usado = $scope.codigo;
                                if(data.codigo.descuento>0){
                                    analitica.descuento = data.codigo.descuento;
                                }

                                var existeCarrito = vm.existeCarrito(analitica);
                                if(!existeCarrito){
                                    analitica.checked = true;
                                    vm.analiticasCarrito.push(analitica);
                                }else{
                                    existeCarrito.checked = (existeCarrito.checked ? false : true);
                                }
                                vm.getTiposMuestraNecesarias();
                                vm.getReglas();
                                
                                vm.codigoModal.close();
                            }else{
                                $timeout(function(){
                                    $scope.errorMsg = true;
                                    //console.log($scope);
                                })
                                analitica.checked = false;
                            }
                        });
                    }

                    $scope.koForm = function(){
                        analitica.checked = false;
                        vm.codigoModal.close();
                        //console.log(vm.existeCarritoChecked(analitica));
                        //console.log(analitica.checked);
                    }
                   
                  }
              });
            }else{
                var existeCarrito = vm.existeCarrito(analitica);
                if(!existeCarrito){
                    analitica.checked = true;
                    vm.analiticasCarrito.push(analitica);
                }else{
                    existeCarrito.checked = (existeCarrito.checked ? false : true);
                    existeCarrito.descuento = analitica.descuento;
                }
                vm.getTiposMuestraNecesarias();
                vm.getReglas();
            }
        }
        vm.getAnimalesCentro();

        vm.contarCarrito = function(){
            var cont = 0;
            //console.log(vm.analiticasCarrito);
            for(var contAn = 0;contAn<vm.analiticasCarrito.length;contAn++){
                if(vm.analiticasCarrito[contAn].checked){
                    cont++;
                }
            }
            return cont;
        }

        vm.informacionAmpliadaPet = function(){
            var res = false;
            //analiticas que se muestra la informacion extra de la peticion
            var analiticasArray = ["pelos","citologia","biopsia","liquido"];
            for(var contAn = 0;contAn<vm.analiticasCarrito.length && !res;contAn++){
                if(vm.analiticasCarrito[contAn].checked){
                    if(typeof(vm.analiticasCarrito[contAn].formulario) != 'undefined' && analiticasArray.indexOf(vm.analiticasCarrito[contAn].formulario) != -1){
                        res = true;
                    }else{
                        if(vm.analiticasCarrito[contAn].grupoanaliticas_id){
                            var splitAnaliticas = vm.analiticasCarrito[contAn].grupoanaliticas_id.split(",");
                            for(var cont=0;cont<splitAnaliticas.length && !res;cont++){
                                for(var cont2=0;cont2<vm.analiticas.length && !res;cont2++){
                                    if(vm.analiticas[cont2].id==splitAnaliticas[cont]){
                                        if(typeof(vm.analiticas[cont2].formulario)!='' && analiticasArray.indexOf(vm.analiticas[cont2].formulario) != -1){
                                            res = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    
                }
            }
            //console.log(res);
            return res;
        }

        vm.informacionAmpliada = function(){
            var res = false;
            for(var contAn = 0;contAn<vm.analiticasCarrito.length && !res;contAn++){
                if(vm.analiticasCarrito[contAn].checked){
                    if(vm.analiticasCarrito[contAn].formulario){
                        res = true;
                    }else{
                        if(vm.analiticasCarrito[contAn].grupoanaliticas_id){
                            var splitAnaliticas = vm.analiticasCarrito[contAn].grupoanaliticas_id.split(",");
                            for(var cont=0;cont<splitAnaliticas.length && !res;cont++){
                                for(var cont2=0;cont2<vm.analiticas.length && !res;cont2++){
                                    if(vm.analiticas[cont2].id==splitAnaliticas[cont]){
                                        if(vm.analiticas[cont2].formulario){
                                            res = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    
                }
            }
            return res;
        }

        vm.revisarBlock = function(){
            var res = true;
            for(var contAn = 0;contAn<vm.analiticasCarrito.length && res;contAn++){
                //console.log("extra",vm.analiticasCarrito[contAn]);
                if(angular.isDefined(vm.analiticasCarrito[contAn].extra) && angular.isDefined(vm.analiticasCarrito[contAn].extra[0]) && angular.isDefined(vm.analiticasCarrito[contAn].extra[0].analitica) && vm.analiticasCarrito[contAn].extra[0].analitica.blockContinue && vm.analiticasCarrito[contAn].checked){
                    res = false;
                }
            }
            return res;
        }

        vm.getExtras = function(analitica){
            //console.log(analitica.extra);
            if(typeof(analitica.extra)=='undefined'){
                analitica.extra = [{ analitica: { 
                    id: analitica.id, 
                    nombre:analitica.nombre,
                    formulario_resultado:analitica.formulario_resultado, 
                    formulario:analitica.formulario, 
                    formulario_ocultartipo: analitica.formulario_ocultartipo, 
                    formulario_multiple:analitica.formulario_multiple,
                    formulario_derma: analitica.formulario_derma,
                    formulario_tumoral:analitica.formulario_tumoral
                },muestras:[{}],tumores:[{organo:''}]}];
            }else{
                return analitica.extra;
            }
            analitica.extra = [];
            //for(var contAn = 0;contAn<vm.analiticasCarrito.length && !res;contAn++){
                if(analitica.checked){
                    if(analitica.formulario){
                        analitica.extra.push({ analitica: { 
                            id: analitica.id, 
                            nombre:analitica.nombre, 
                            formulario_resultado:analitica.formulario_resultado, 
                            formulario:analitica.formulario, 
                            formulario_ocultartipo:analitica.formulario_ocultartipo, 
                            formulario_multiple:analitica.formulario_multiple,
                            formulario_derma:analitica.formulario_derma,
                            formulario_tumoral:analitica.formulario_tumoral
                        }, muestras:[{}],tumores:[{organo:''}]});
                    }else{
                        if(analitica.grupoanaliticas_id){
                            var splitAnaliticas = analitica.grupoanaliticas_id.split(",");
                            //BUSCAMOS LAS ANALITICAS DEL GRUPO
                            AnalisisService.getAnaliticasPerfil(analitica.id,function(data){

                                for(var cont=0;cont<splitAnaliticas.length;cont++){
                                    var resAn = false;
                                    for(var cont2=0;cont2<data.analiticas.length && !resAn;cont2++){
                                        if(data.analiticas[cont2].id==splitAnaliticas[cont]){
                                            if(data.analiticas[cont2].formulario){
                                                analitica.extra.push({analitica: { 
                                                    id: data.analiticas[cont2].id, 
                                                    nombre:data.analiticas[cont2].nombre, 
                                                    formulario:data.analiticas[cont2].formulario, 
                                                    formulario_resultado:data.analiticas[cont2].formulario_resultado, 
                                                    formulario_ocultartipo:data.analiticas[cont2].formulario_ocultartipo, 
                                                    formulario_multiple:data.analiticas[cont2].formulario_multiple,
                                                    formulario_derma: data.analiticas[cont2].formulario_derma,
                                                    formulario_tumoral:data.analiticas[cont2].formulario_tumoral
                                                }, 
                                                muestras:[{}],
                                                tumores:[{organo:''}]
                                            });
                                                resAn = true;
                                            }
                                        }
                                    }
                                }
                            })
                        }
                    }
                    
                }
            //}
            console.log(analitica.extra);
            return analitica.extra;
        }
               
    }


})();